//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibCookieConsentModal',
  components: {
    FibPrivacyPolicy: require("../pages/modals/PrivacyPolicy").default
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showPrivacy: false
    };
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    style: function style() {
      return {
        fontFamily: this.theme.fontFamily
      };
    }
  }
};